import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const highlightId = new URLSearchParams(window.location.search).get("highlight")
    if (!highlightId) return

    const element = document.getElementById(highlightId)
    if (!element) return

    // Wait for DOM to be fully rendered
    setTimeout(() => {
      const rect = element.getBoundingClientRect()
      const targetY = window.scrollY + rect.top - 20
      window.scrollTo(0, Math.max(0, targetY))
      
      element.classList.add("audit-history__entry--highlighted")

      setTimeout(() => {
        element.classList.remove("audit-history__entry--highlighted")
      }, 2500)
    }, 50)
  }
}
